var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "has-logo" },
    [
      _c("logo", { attrs: { collapse: _vm.isCollapse } }),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.activeMenu,
                collapse: _vm.isCollapse,
                "background-color": _vm.menuTheme.background,
                "text-color": _vm.menuTheme.text,
                "unique-opened": false,
                "default-openeds": _vm.defaultOpeneds,
                "active-text-color": _vm.menuTheme.activeText,
                "collapse-transition": false,
                mode: "vertical"
              }
            },
            _vm._l(_vm.routes, function(route) {
              return _c("sidebar-item", {
                key: route.path,
                attrs: { item: route, "base-path": route.path }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }